//  获取unix时间戳
export default function(date) {
  if (!(date && date instanceof Date)) {
    date = new Date();
  }
  return Math.ceil(date.getTime() / 1000);
}



// WEBPACK FOOTER //
// ./app/web/asset/js/utils/unix.js